// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.book-simulator {
    position: relative;
    width: 100%;
    height: 100%;
}

div.book-simulator-body {
    width: 100%;
    height: 100%;
}

    div.book-simulator-body > svg {
        position: absolute;
        width: 100%;
        height: 100%;
    }

div.right-page-underlay {
    position: absolute;
    background-color: var(--color-paper);
    left: var(--right-page-x);
    top: var(--image-mask-y);
    width: var(--right-page-width);
    height: var(--image-mask-height);
}

    div.right-page-underlay.hide {
        opacity: 0;
    }

    div.right-page-underlay.show {
        opacity: 1;
    }

div.flipPageList {
    position: absolute;
    left: var(--image-mask-x);
    top: var(--image-mask-y);
    width: var(--image-mask-width);
    height: var(--image-mask-height);
    object-fit: cover;
    perspective: 1200px;
}

div.flipPage {
    position: absolute;
    width: 100%;
    height: 100%;
    transform-origin: right center;
    transform: rotateY(-10deg);
}

    div.flipPage > img {
        position: absolute;
        width: 100%;
        height: 100%;
    }

    div.flipPage.unflipped > img {
        display: none;
    }

    div.flipPage.flipped > img {
        display: block;
    }

g#leftPageLayer.show {
    opacity: 1;
}

g#leftPageLayer.hide {
    opacity: 0;
}

g#rightPageLayer.show {
    opacity: 1;
}

g#rightPageLayer.hide {
    opacity: 0;
}

g#FlickerLayer-25percent {
    opacity: 0;
}

g#FlickerLayer-50percent {
    opacity: 0;
}

g#FlickerLayer-75percent {
    opacity: 0;
}

g#LeftPageStack > path.show {
    opacity: 1;
}

g#LeftPageStack > path.hide {
    opacity: 0;
}

g#RightPageStack > path.show {
    opacity: 1;
}

g#RightPageStack > path.hide {
    opacity: 0;
}

g#holdingThumb.show {
    opacity: 1;
}

g#holdingThumb.hide {
    opacity: 0;
}


div.book-simulator-body.turning > svg > g#FlickerLayer-25percent {
    animation-name: page-turn-fade-in;
    animation-direction: normal;
    animation-delay: 0ms;
    animation-duration: 100ms;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
}

div.book-simulator-body.turning > svg > g#FlickerLayer-50percent {
    animation-name: page-turn-fade-in;
    animation-direction: normal;
    animation-delay: 300ms;
    animation-duration: 100ms;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
}

div.book-simulator-body.turning > svg > g#FlickerLayer-75percent {
    animation-name: page-turn-fade-in;
    animation-direction: normal;
    animation-delay: 600ms;
    animation-duration: 100ms;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
}

div.book-simulator-body.turning > svg > g#LeftPageStack > path:nth-last-child(-n+5) {
    animation-name: stack-page-landing-wobble;
    animation-direction: normal;
    animation-delay: 0ms;
    animation-duration: 100ms;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
}

@keyframes page-turn-fade-in {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

@keyframes stack-page-landing-wobble {
    0% {
        transform: translateX(0px);
    }

    50% {
        transform: translateX(-1px);
    }

    100% {
        transform: translateX(0px);
    }
}
`, "",{"version":3,"sources":["webpack://./src/Controls/Simulators/css/BookPagesSimulator.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;IAEI;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;IAChB;;AAEJ;IACI,kBAAkB;IAClB,oCAAoC;IACpC,yBAAyB;IACzB,wBAAwB;IACxB,8BAA8B;IAC9B,gCAAgC;AACpC;;IAEI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;AAEJ;IACI,kBAAkB;IAClB,yBAAyB;IACzB,wBAAwB;IACxB,8BAA8B;IAC9B,gCAAgC;IAChC,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,0BAA0B;AAC9B;;IAEI;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;AAEJ;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,iCAAiC;IACjC,2BAA2B;IAC3B,oBAAoB;IACpB,yBAAyB;IACzB,6BAA6B;IAC7B,iCAAiC;IACjC,mCAAmC;AACvC;;AAEA;IACI,iCAAiC;IACjC,2BAA2B;IAC3B,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;IAC7B,iCAAiC;IACjC,mCAAmC;AACvC;;AAEA;IACI,iCAAiC;IACjC,2BAA2B;IAC3B,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;IAC7B,iCAAiC;IACjC,mCAAmC;AACvC;;AAEA;IACI,yCAAyC;IACzC,2BAA2B;IAC3B,oBAAoB;IACpB,yBAAyB;IACzB,6BAA6B;IAC7B,iCAAiC;IACjC,mCAAmC;AACvC;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":["div.book-simulator {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\ndiv.book-simulator-body {\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n    div.book-simulator-body > svg {\r\n        position: absolute;\r\n        width: 100%;\r\n        height: 100%;\r\n    }\r\n\r\ndiv.right-page-underlay {\r\n    position: absolute;\r\n    background-color: var(--color-paper);\r\n    left: var(--right-page-x);\r\n    top: var(--image-mask-y);\r\n    width: var(--right-page-width);\r\n    height: var(--image-mask-height);\r\n}\r\n\r\n    div.right-page-underlay.hide {\r\n        opacity: 0;\r\n    }\r\n\r\n    div.right-page-underlay.show {\r\n        opacity: 1;\r\n    }\r\n\r\ndiv.flipPageList {\r\n    position: absolute;\r\n    left: var(--image-mask-x);\r\n    top: var(--image-mask-y);\r\n    width: var(--image-mask-width);\r\n    height: var(--image-mask-height);\r\n    object-fit: cover;\r\n    perspective: 1200px;\r\n}\r\n\r\ndiv.flipPage {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    transform-origin: right center;\r\n    transform: rotateY(-10deg);\r\n}\r\n\r\n    div.flipPage > img {\r\n        position: absolute;\r\n        width: 100%;\r\n        height: 100%;\r\n    }\r\n\r\n    div.flipPage.unflipped > img {\r\n        display: none;\r\n    }\r\n\r\n    div.flipPage.flipped > img {\r\n        display: block;\r\n    }\r\n\r\ng#leftPageLayer.show {\r\n    opacity: 1;\r\n}\r\n\r\ng#leftPageLayer.hide {\r\n    opacity: 0;\r\n}\r\n\r\ng#rightPageLayer.show {\r\n    opacity: 1;\r\n}\r\n\r\ng#rightPageLayer.hide {\r\n    opacity: 0;\r\n}\r\n\r\ng#FlickerLayer-25percent {\r\n    opacity: 0;\r\n}\r\n\r\ng#FlickerLayer-50percent {\r\n    opacity: 0;\r\n}\r\n\r\ng#FlickerLayer-75percent {\r\n    opacity: 0;\r\n}\r\n\r\ng#LeftPageStack > path.show {\r\n    opacity: 1;\r\n}\r\n\r\ng#LeftPageStack > path.hide {\r\n    opacity: 0;\r\n}\r\n\r\ng#RightPageStack > path.show {\r\n    opacity: 1;\r\n}\r\n\r\ng#RightPageStack > path.hide {\r\n    opacity: 0;\r\n}\r\n\r\ng#holdingThumb.show {\r\n    opacity: 1;\r\n}\r\n\r\ng#holdingThumb.hide {\r\n    opacity: 0;\r\n}\r\n\r\n\r\ndiv.book-simulator-body.turning > svg > g#FlickerLayer-25percent {\r\n    animation-name: page-turn-fade-in;\r\n    animation-direction: normal;\r\n    animation-delay: 0ms;\r\n    animation-duration: 100ms;\r\n    animation-fill-mode: forwards;\r\n    animation-timing-function: linear;\r\n    animation-iteration-count: infinite;\r\n}\r\n\r\ndiv.book-simulator-body.turning > svg > g#FlickerLayer-50percent {\r\n    animation-name: page-turn-fade-in;\r\n    animation-direction: normal;\r\n    animation-delay: 300ms;\r\n    animation-duration: 100ms;\r\n    animation-fill-mode: forwards;\r\n    animation-timing-function: linear;\r\n    animation-iteration-count: infinite;\r\n}\r\n\r\ndiv.book-simulator-body.turning > svg > g#FlickerLayer-75percent {\r\n    animation-name: page-turn-fade-in;\r\n    animation-direction: normal;\r\n    animation-delay: 600ms;\r\n    animation-duration: 100ms;\r\n    animation-fill-mode: forwards;\r\n    animation-timing-function: linear;\r\n    animation-iteration-count: infinite;\r\n}\r\n\r\ndiv.book-simulator-body.turning > svg > g#LeftPageStack > path:nth-last-child(-n+5) {\r\n    animation-name: stack-page-landing-wobble;\r\n    animation-direction: normal;\r\n    animation-delay: 0ms;\r\n    animation-duration: 100ms;\r\n    animation-fill-mode: forwards;\r\n    animation-timing-function: linear;\r\n    animation-iteration-count: infinite;\r\n}\r\n\r\n@keyframes page-turn-fade-in {\r\n    0% {\r\n        opacity: 1;\r\n    }\r\n\r\n    100% {\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n@keyframes stack-page-landing-wobble {\r\n    0% {\r\n        transform: translateX(0px);\r\n    }\r\n\r\n    50% {\r\n        transform: translateX(-1px);\r\n    }\r\n\r\n    100% {\r\n        transform: translateX(0px);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
